export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/Block1-5d9839bbf9bada762716754c116fb321.png";